var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home{background:url(" + escape(require("../../src/assets/pizza.jpg")) + ");height:800px;padding:10%}h1,h2{margin:6%}.background{background:#eee;opacity:.8;max-width:60%;margin:0 auto;padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-158d697b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 44
// module chunks = 0